import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Router navigation keeps the scroll position by default, which lands you
 * mid-page after following a link from a mega-menu. In-page anchors
 * (`/tracelock#evidence`) are left alone so they still work.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
